<template>
  <div class="leaderboard__wrapper my-4">
    <v-card flat class="grey lighten-4 mx-auto d-flex align-center" width="320" height="100">
      <v-card-text class="text-center text-overline accent--text">LARGE MOBILE BANNER 320 x 100</v-card-text>
    </v-card>
  </div>
</template>

<script>
  export default {
    name: 'MobileBanner'
  }
</script>